import type { T_Maybe } from '@tryiris-ai/js-types';

/** Command directive. */
export type Directive<T extends Command = Command, U = unknown> = Readonly<{
  /** Command. */
  command: T;

  /** Directive-specific data. */
  data?: T_Maybe<U>;
}>;

/** Studio command. */
export enum Command {
  CONTROL_GROUP_NEXT = 'control.group.next',
  CONTROL_GROUP_PREV = 'control.group.prev',
  CONTROL_PRESET_01 = 'control.preset.01',
  CONTROL_PRESET_02 = 'control.preset.02',
  CONTROL_PRESET_03 = 'control.preset.03',
  CONTROL_PRESET_04 = 'control.preset.04',
  CONTROL_PRESET_05 = 'control.preset.05',
  CONTROL_PRESET_06 = 'control.preset.06',
  CONTROL_PRESET_07 = 'control.preset.07',
  CONTROL_PRESET_08 = 'control.preset.08',
  CONTROL_PRESET_09 = 'control.preset.09',
  CONTROL_PRESET_10 = 'control.preset.10',
  CONTROL_PRESET_ADD = 'control.preset.add',
  FOCUS_FAR = 'focus.far',
  FOCUS_MODE = 'focus.mode',
  FOCUS_NEAR = 'focus.near',
  FOCUS_ONE_PUSH = 'focus.one-push',
  FOCUS_STOP = 'focus.stop',
  PACE_PT_DOWN = 'pace.pt.down',
  PACE_PT_UP = 'pace.pt.up',
  PACE_ZOOM_DOWN = 'pace.zoom.down',
  PACE_ZOOM_UP = 'pace.zoom.up',
  PTZ_PAN = 'ptz.pan',
  PTZ_PAN_LEFT = 'ptz.pan.left',
  PTZ_PAN_MAX = 'ptz.pan.max',
  PTZ_PAN_MIN = 'ptz.pan.min',
  PTZ_PAN_RIGHT = 'ptz.pan.right',
  PTZ_STOP = 'ptz.stop',
  PTZ_TILT = 'ptz.tilt',
  PTZ_TILT_DOWN = 'ptz.tilt.down',
  PTZ_TILT_MAX = 'ptz.tilt.max',
  PTZ_TILT_MIN = 'ptz.tilt.min',
  PTZ_TILT_UP = 'ptz.tilt.up',
  PTZ_ZOOM = 'ptz.zoom',
  PTZ_ZOOM_IN = 'ptz.zoom.in',
  PTZ_ZOOM_LOCK = 'ptz.zoom.lock',
  PTZ_ZOOM_MAX = 'ptz.zoom.max',
  PTZ_ZOOM_MIN = 'ptz.zoom.min',
  PTZ_ZOOM_OUT = 'ptz.zoom.out',
  QUICK_PAN_LEFT = 'quick.pan.left',
  QUICK_PAN_RIGHT = 'quick.pan.right',
  QUICK_STOP = 'quick.stop',
  QUICK_TILT_DOWN = 'quick.tilt.down',
  QUICK_TILT_UP = 'quick.tilt.up',
  QUICK_ZOOM_IN = 'quick.zoom.in',
  QUICK_ZOOM_OUT = 'quick.zoom.out',
  TEMPO_PT_TOGGLE = 'tempo.pt.toggle',
  TOOL_CENTER = 'tool.center',
  TOOL_CINE_CENTER = 'tool.cine-center',
  TOOL_FAST_FRAME = 'tool.fast-frame',
  TOOL_CINE_FRAME = 'tool.cine-frame',
  TOOL_JOYSTICK = 'tool.joystick',
  TOOL_JOYSTICK_TRIGGER = 'tool.joystick.trigger',
  TOOL_NEXT = 'tool.next',
  TOOL_PREV = 'tool.prev',
  TOOL_TRACKING = 'tool.tracking',
  TOOL_ZOOM = 'tool.zoom',
  TRAY_BOTTOM_TAB = 'tray.bottom.tab',
  TRAY_LEFT_TAB = 'tray.left.tab',
  TRAY_RIGHT_TAB = 'tray.right.tab',
  VIDEO_ARRANGEMENT = 'video.arrangement',
  VIDEO_SOURCE_01 = 'video.source.01',
  VIDEO_SOURCE_02 = 'video.source.02',
  VIDEO_SOURCE_03 = 'video.source.03',
  VIDEO_SOURCE_04 = 'video.source.04',
  VIDEO_SOURCE_05 = 'video.source.05',
  VIDEO_SOURCE_06 = 'video.source.06',
  VIDEO_SOURCE_07 = 'video.source.07',
  VIDEO_SOURCE_08 = 'video.source.08',
  VIDEO_SOURCE_09 = 'video.source.09',
  VIDEO_SOURCE_10 = 'video.source.10',
  VIDEO_SOURCE_NEXT = 'video.source.next',
  VIDEO_SOURCE_PREV = 'video.source.prev',
  PT_SPEED_UP = 'pt.speed.up',
  PT_SPEED_DOWN = 'pt.speed.down'
}
